// @ts-ignore
/* eslint-disable */
import { request } from 'umi'

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser (options?: { [key: string]: any }) {
  return request<API.ResponseData<API.CurrentUser>>('/core/user/info', {
    method: 'GET',
    ...(options || {})
  })
}

export async function queryCurrentTenant(params: { domain: string }) {
  return request<API.ResponseData<API.CurrentTenant>>('/core/tenant', {
    params
  })
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices (options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {})
  })
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getMenuTreeBase() {
  return request('/manage/administrator/administrator/getPermission', {
    method: 'GET',
    params: {
      // TODO: 伯朗租户的健康管理系统菜单权限只能使用 `health-management` 字段获取, 其他租户的健康管理系统使用 `full-health-management`, 后期统一字段, 废弃掉 `full-health-management`
      domain: new URL(process.env.ORIGIN ?? window.origin).hostname === 'bolang.lcchunyi.com'
        ? 'health-management'
        : 'full-health-management', // will `health-management` instead
    },
  }).then((res) => {
    if (res.success === true) {
      return res.data
    } else {
      return []
    }
  })
}
